/* eslint-disable no-case-declarations */
import { MessageBox, Loading } from "element-ui";
import { reportG2 } from "./../services/reportG2.service";
import { Operator_service } from "../services/Operator_service";
import { Typegroup_service } from "../services/Typegroup.service";
import moment from "moment"

const month_th = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน ","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"]
const short_month = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']
const service_th = {
    Voice : 'บริการประเภทเสียง',
    SMS : 'บริการ SMS ',
    MMS : 'บริการ MMS ',
    Internet : 'บริการ Internet ',
    All : 'บริการประเภทเสียง บริการ SMS/MMS และบริการ Internet '
}
const unit_service = {
    Voice : 'บาท / นาที',
    SMS : 'บาท / ข้อความ',
    MMS : 'บาท / ข้อความ',
    Internet : 'บาท / MB'
}
const fq_th = {
    900 : ' 900 MHz ',
    1800 : ' 1800 MHz ',
    2100 : ' 2.1 GHz ',
    other : 'อื่น ๆ '
}
const state = {
    provider_group : [],
    provider_list : [],
    charts : {
        unit : {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: ['Jan'],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.25,
                title: {
                    text: 'อัตราเฉลี่ย'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        voice : {
            chart: {
                id: 'voice',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [""],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'Voice (บาท/นาที)'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: false,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        sms : {
            chart: {
                id: 'sms',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ SMS '
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        mms : {
            chart: {
                id: 'mms',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ MMS '
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        internet : {
            chart: {
                id: 'internet',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.05,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ Internet'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
    },
    displayCharts : [],
    datasets: [],
    options: {},
    dataTable: [],
    showDataTable: false,
    chartResult: false,
    showDataNotFound: false,
    loading : true,
    regulator : [],
    showRegulate : false
}
const actions = {
    async getGroupCompany({commit},type){
        let obj = { provider_type : type}
        let result = await Typegroup_service.getGroupList(obj)
        if(result.status === 200){
          commit('PROVIDER_GROUP',result.data)
        }else {
          MessageBox.confirm(result.message, 'แจ้งเตือน', {
              confirmButtonText: 'ตกลง',
              showCancelButton: false,
              type: 'warning'
          })
        }
    },
    async getRegulateRate({commit},formdata){
        let result = await reportG2.getAvgRegulate('')
        if(result.status == 200){
            commit('SET_REGULATE_LIST',result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })  
        }
    },
    async getProviderByType({commit},type){
        let result = await Operator_service.getProviderList(type)
        if(result.status === 200){
            commit('PROVIDER_LIST',result.data)
        }else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async reportMonth({commit},formdata){ // === REPORT MONTH ===
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await reportG2.getAllReportData(formdata)
        if(!result.data) {
            setTimeout(function() { loadingInstance.close() }, 250)
            return commit('DATA_NOT_FOUND',true)
        }
        let proportion = await reportG2.getProportionMobileRate()
            proportion = proportion.data[0] || null
            proportion['main'] = proportion.proportion_main_promotion*0.01 || 1
            proportion['on-top'] = proportion.proportion_ontop_promotion*0.01 || 1
        let regulator = state.regulator
            regulator = formdata.graphLine ? regulator.filter(item => item.id == formdata.graphLine)[0] : null
        let daterange = result.data.pop()
            formdata.daterange = daterange
        let tmp = {
            milestone: [],
            data: [],
            pointer: {},
            providers: {},
            category: {
                Voice: {},
                SMS: {},
                MMS: {},
                Internet: {}
            },
            bucket: {},
            count: {},
            group: {},
            average: [],
            color: {
                Voice: '#ffbb33',
                SMS: '#66b3ff',
                MMS: '#66ffb3',
                Internet: '#ff3838'
            },
            proportion: {}
        }
        let qrydata = Object.values(result.data[0])[0]
        let services = formdata.typeService ? [formdata.typeService] : Object.keys(tmp.category)
        let fq_text = '',fq_pool = [].concat(formdata.frequency)
        if(fq_pool.length == 1){
            fq_text  = 'บนคลื่นความถี่'+fq_th[fq_pool[0]]
        }else if((fq_pool.length == 2) || (fq_pool.length == 3)){
            let last_item = fq_pool.pop()
            fq_text = 'บนคลื่นความถี่'
            for(let item of fq_pool){
                fq_text += fq_th[item]+' '
            }
            fq_text += 'และ '+fq_th[last_item]+''
        }
        for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
            let date_key = moment(date).format('MM-YYYY')
            tmp.milestone.push(short_month[moment(date).month()]+'-'+moment(date).add(543,'Y').format('YY'))
            tmp.bucket[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            tmp.proportion[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            tmp.count[date_key] = { Voice : {}, SMS : {}, MMS : {}, Internet : {} }
            tmp.group[date_key] = { Voice : {}, SMS : {}, MMS : {}, Internet : {} }
            if(formdata.compare_type == 'group'){ // === GROUP ===
                for(let pv of formdata.list){
                    for(let id of JSON.parse(pv.group_company_list)){
                        tmp.pointer[id] = pv.group_name_th
                        for(let sv of services){
                            tmp.proportion[date_key][sv][id] = { 'main' : 0 , 'on-top' : 0}
                        }
                    }
                    tmp.providers[pv.group_name_th] = {color : pv.group_color_code}
                    for(let category in tmp.category){
                        tmp.bucket[date_key][category][pv.group_name_th] = 0
                        tmp.count[date_key][category][pv.group_name_th] = []
                        tmp.group[date_key][category][pv.group_name_th] = 0
                    } 
                }
            }else{ // === UNGROUP ===
                for(let pv of formdata.list){
                    tmp.pointer[pv.id] = pv.brand_name
                    tmp.providers[pv.brand_name] = {color : pv.provider_color}
                    for(let category in tmp.category){
                        tmp.bucket[date_key][category][pv.brand_name] = 0
                        tmp.proportion[date_key][category][pv.id] = { 'main' : 0 , "on-top" : 0}
                        tmp.count[date_key][category][pv.id] = []
                    } 
                }
            }
        }
        if(formdata.distinguish){ // ===  CLASSIFY BY PROVIDER ===
            for(let item of qrydata){
                let date_key = moment(item.monthly_regulate).format('MM-YYYY')
                if(item.price_avg){
                    tmp.bucket[date_key][item.service_type][tmp.pointer[item.provider_id]] = item.price_avg
                }else{
                    for(let sv of services){
                        tmp.proportion[date_key][sv][item.provider_id][item.promotion_type] = item[sv]
                        tmp.group[date_key][sv][tmp.pointer[item.provider_id]] += (item[sv] > 0 && item.promotion_type == 'main') ? 1 : 0
                        tmp.count[date_key][sv][tmp.pointer[item.provider_id]] = (parseInt(tmp.count[date_key][sv][tmp.pointer[item.provider_id]]) || 0) + item[sv+'_total']  
                    }
                }
            }
            for(let date in tmp.proportion){
                for(let service in tmp.proportion[date]){
                    for(let p_id in tmp.proportion[date][service]){
                        let item = tmp.proportion[date][service][p_id]
                        tmp.bucket[date][service][tmp.pointer[p_id]] += (item['on-top'] > 0 ? (item['main']*proportion['main'])+(item['on-top']*proportion['on-top']) : item.main)
                    }
                }
            }
            if(formdata.compare_type == 'group'){ 
                for(let date in tmp.group){
                    for(let service in tmp.group[date]){
                        for(let provider in tmp.group[date][service]){
                            if(tmp.group[date][service][provider]>1){
                                tmp.bucket[date][service][provider] /= tmp.group[date][service][provider]
                            } 
                        }
                    }
                }
            }
            if(formdata.barAvg){ // === AVERAGE COLUMN ===
                if(formdata.weighting){
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
                            let date_key = moment(date,'YYYY-MM-DD').format('MM-YYYY')
                            let pre_weight = 0
                            let total_weight = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[date_key][sv][provider] > 0){
                                    tmp.category[sv][provider] 
                                    ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[date_key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[date_key][sv][provider])] 
                                pre_weight += tmp.bucket[date_key][sv][provider] * tmp.count[date_key][sv][provider]
                                total_weight += tmp.count[date_key][sv][provider]
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((pre_weight/total_weight)) || null)
                        }
                    }
                }else{ // === NOT WEIGHTING ===
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
                            let date_key = moment(date,'YYYY-MM-DD').format('MM-YYYY')
                            let sum = 0
                            let devide = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[date_key][sv][provider] > 0){
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[date_key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[date_key][sv][provider])] 
                                    sum += tmp.bucket[date_key][sv][provider]
                                    devide += 1
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((sum/devide)) || null)
                        }
                    }
                }
            }else{ // === NOT AVERAGE ===
                for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
                    let date_key = moment(date,'YYYY-MM-DD').format('MM-YYYY')
                    for(let provider in tmp.providers){
                        tmp.category.Voice[provider] ? tmp.category.Voice[provider].push(tmp.bucket[date_key].Voice[provider] > 0 ? parseFloat(tmp.bucket[date_key].Voice[provider]) : null) 
                                                    : tmp.category.Voice[provider] = [tmp.bucket[date_key].Voice[provider] > 0 ? parseFloat(tmp.bucket[date_key].Voice[provider]) : null] 
                        tmp.category.SMS[provider] ? tmp.category.SMS[provider].push(tmp.bucket[date_key].SMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].SMS[provider]) : null)     
                                                    : tmp.category.SMS[provider] = [tmp.bucket[date_key].SMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].SMS[provider]) : null] 
                        tmp.category.MMS[provider] ? tmp.category.MMS[provider].push(tmp.bucket[date_key].MMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].MMS[provider]) : null)     
                                                    : tmp.category.MMS[provider] = [tmp.bucket[date_key].MMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].MMS[provider]) : null] 
                        tmp.category.Internet[provider] ? tmp.category.Internet[provider].push(tmp.bucket[date_key].Internet[provider] > 0 ? parseFloat(tmp.bucket[date_key].Internet[provider]) : null) 
                                                        : tmp.category.Internet[provider] = [tmp.bucket[date_key].Internet[provider] > 0 ? parseFloat(tmp.bucket[date_key].Internet[provider]) : null]
                    }
                }
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast =  await reportG2.getForcastAvg(formdata)
                let devider = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast_count = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                tmp.forcast = {}
                for(let service of services){
                    tmp.forcast[service] = {}
                    for(let provider in tmp.providers){
                        tmp.forcast[service][provider] = []
                    }
                }
                for(let item of forcast.data){
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][provider_name].push(item.price_avg) 
                        devider[item.service_type][provider_name] = parseInt(devider[item.service_type][provider_name] || 0) + 1
                    }else{
                        for(let service of services){
                            tmp.forcast[service][provider_name].push(item[service]*proportion[item.promotion_type])
                            tmp.forcast_count[service][provider_name] = (tmp.forcast_count[service][provider_name] || 0) + (item[service] ? item.total : 0)
                        }
                        if(item.promotion_type == 'main'){
                            item.Voice > 0 ? devider.Voice[provider_name] = (devider.Voice[provider_name] ? devider.Voice[provider_name]+1 : 1) : 0
                            item.SMS > 0 ? devider.SMS[provider_name] = (devider.SMS[provider_name] ? devider.SMS[provider_name]+1 : 1) : 0
                            item.MMS > 0 ? devider.MMS[provider_name] = (devider.MMS[provider_name] ? devider.MMS[provider_name]+1 : 1) : 0
                            item.Internet > 0 ? devider.Internet[provider_name] = (devider.Internet[provider_name] ? devider.Internet[provider_name]+1 : 1) : 0
                        }
                    }
                }

                let avg = [],fc = 0 ,sv_count = 0
                if(formdata.barAvg){ 
                    if(formdata.weighting){ // === WEIGHTING AVERAGE FORCAST ===
                        for(let sv of services){
                            sv_count = eval(Object.values(tmp.forcast_count[sv]).join('+'))
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc*tmp.forcast_count[sv][provider]/sv_count)
                            }
                            tmp.average[sv].push(eval(avg.join('+')))
                        }
                    }else{ // === NORMAL AVERAGE FORCAST ===
                        for(let sv of services){
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc)
                            }
                            tmp.average[sv].push(eval(avg.join('+'))/avg.length)
                        }
                    }
                }else{ // === JUST FORCAST ===
                    for(let sv of services){
                        for(let provider in tmp.providers){
                            fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                            tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                        }
                    }
                }
            }

            for(let service_name of services){ // === PREPARE DATA TO CHARTS ===
                let maxval = 0, maxline = [], reguline = []
                tmp.series = []
                for(let provider in tmp.category[service_name]){ // === HIGHEST LINE ===
                    maxval = maxval > Math.max(...tmp.category[service_name][provider]) ? maxval : Math.max(...tmp.category[service_name][provider])
                    if(formdata.graphLine){
                        tmp.category[service_name][provider].unshift(null)
                        tmp.category[service_name][provider].push(null)
                    } 
                    tmp.series.push({
                        name : provider,
                        data : tmp.category[service_name][provider],
                        color : tmp.providers[provider].color
                    })
                }
                if (formdata.graphLine) { // === REGULATE LINE ===
                    let regulate_val = parseFloat((regulator[service_name.toLowerCase() + '_service_rate']))
                        tmp.min = 1
                        tmp.max = tmp.milestone.length
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null                    
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                    if(formdata.type_report == 'month'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"เดือน"+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"เดือน"+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงเดือน'+month_th[moment(daterange[1]).month()]+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }
                    if(formdata.barAvg){
                        tmp.average[service_name].unshift(null)
                        tmp.average[service_name].push(null)
                    } 
                }else{ // === NO REGULATE LINE ===
                    if(formdata.type_report == 'month'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"เดือน"+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +'เดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงเดือน'+month_th[moment(daterange[1]).month()]+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }
                }
                if (formdata.barAvg) {
                    tmp.series.push({
                        name: 'ค่าเฉลี่ย',
                        data: tmp.average[service_name],
                        color: '#ffcc00'
                    })
                }
                commit('ADD_CHARTS', {
                    title: tmp.title,
                    categories: tmp.milestone,
                    yAxis_text: unit_service[service_name] || 'บาท',
                    yAxis_lines: null,
                    max : tmp.max,
                    min : tmp.min,
                    series: tmp.series,
                    showTable: false,
                })
                if(formdata.avgTable){ // === DATA TABLE ===
                    let milestone = tmp.milestone
                    let provider_data = tmp.series
                    if(formdata.graphLine){
                        provider_data = []
                        milestone = JSON.parse(JSON.stringify(tmp.milestone))
                        milestone.shift()
                        milestone.pop()
                        for(let item in tmp.series){
                            let series = JSON.parse(JSON.stringify(tmp.series[item].data))
                                series.pop()
                                series.shift()
                            provider_data.push({
                                name : tmp.series[item].name,
                                data : series
                            })
                        }
                    }
                    commit('ADD_TABLE', {
                        milestone : milestone,
                        data : provider_data
                    })
                }
            }
        }else{ // === NO CLASSIFY ===
            for(let item of qrydata){
                let date_key = moment(item.monthly_regulate).format('MM-YYYY')
                if(item.price_avg){
                    tmp.proportion[date_key][item.service_type][item.provider_id]['main'] = [item.price_avg].concat(tmp.proportion[date_key][item.service_type][item.provider_id]['main'] || [])
                    tmp.proportion[date_key][item.service_type][item.provider_id]['on-top'] = []
                }else{
                    tmp.proportion[date_key]['Voice'][item.provider_id][item.promotion_type] = [item.Voice].concat(tmp.proportion[date_key]['Voice'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['SMS'][item.provider_id][item.promotion_type] = [item.SMS].concat(tmp.proportion[date_key]['SMS'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['MMS'][item.provider_id][item.promotion_type] = [item.MMS].concat(tmp.proportion[date_key]['MMS'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['Internet'][item.provider_id][item.promotion_type] = [item.Internet].concat(tmp.proportion[date_key]['Internet'][item.provider_id][item.promotion_type] || [])
                }
            }
            for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
                let date_key = moment(date,'YYYY-MM-DD').format('MM-YYYY')
                for(let sv of services){
                    tmp.bucket[date_key][sv] = []
                    tmp.category[sv] = tmp.category[sv].length ? tmp.category[sv] : []
                    for(let pv in tmp.proportion[date_key][sv]){
                        if(!!tmp.proportion[date_key][sv][pv]['on-top'][0]){
                            var main = tmp.proportion[date_key][sv][pv]['main'][0] ? eval(tmp.proportion[date_key][sv][pv]['main'].join('+'))*proportion['main'] : 0
                            tmp.bucket[date_key][sv].push(main+(eval(tmp.proportion[date_key][sv][pv]['on-top'].join('+'))*proportion['on-top']))
                        }else{
                            if(tmp.proportion[date_key][sv][pv]['main'][0]){
                                tmp.bucket[date_key][sv].push(eval(tmp.proportion[date_key][sv][pv]['main'].join('+')))
                            }
                        }
                    }
                   tmp.bucket[date_key][sv] = eval(tmp.bucket[date_key][sv].join('+')) / tmp.bucket[date_key][sv].length
                } // === AVG DATA OF PROVIDERS ===
                for(let service of services){
                    tmp.category[service].push(parseFloat(tmp.bucket[date_key][service]) || null)
                }
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast =  await reportG2.getForcastAvg(formdata)
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                for(let provider in tmp.providers){
                    tmp.forcast.Voice[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.SMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.MMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.Internet[provider] = {'main' : null , 'on-top' : null}
                }
                for(let item of forcast.data){ // === QUERY DATA FORCAST ===
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][tmp.pointer[item.provider_id]]['main'] = item.price_avg
                    }else{
                        tmp.forcast.Voice[tmp.pointer[item.provider_id]][item.promotion_type] = item.Voice
                        tmp.forcast.SMS[tmp.pointer[item.provider_id]][item.promotion_type] = item.SMS
                        tmp.forcast.MMS[tmp.pointer[item.provider_id]][item.promotion_type] = item.MMS
                        tmp.forcast.Internet[tmp.pointer[item.provider_id]][item.promotion_type] = item.Internet
                    }
                }
                for(let service of services){ // === PROPORTION OF FORCAST DATA ===
                    for(let provider in tmp.forcast[service]){
                        var item = tmp.forcast[service][provider]
                        tmp.forcast[service][provider] = item['on-top'] > 0 ? item['main'] > 0 ? (item['main']*proportion['main'])+(item['on-top']*proportion['on-top']) : item['on-top'] : item['main']
                    }
                    var dataset = Object.values(tmp.forcast[service]).filter(item => item > 0)
                    var avg = eval(dataset.join('+')) / dataset.length
                    tmp.category[service].push(avg)
                }
            }
            if(!formdata.typeService){ // === ALL SERVICE TYPE ===
                if(formdata.type_report == 'between_month'){
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +'ระหว่างเดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                    +' ถึงเดือน'+month_th[moment(daterange[1]).month()]+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                }else{
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +'เดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                }
                let provider_data = [{
                    name : 'บริการประเภทเสียง',
                    data : tmp.category.Voice,
                    color : tmp.color.Voice
                },{
                    name : 'บริการ SMS',
                    data : tmp.category.SMS,
                    color : tmp.color.SMS
                },{
                    name : 'บริการ MMS',
                    data : tmp.category.MMS,
                    color : tmp.color.MMS
                },{
                    name : 'บริการ Internet',
                    data : tmp.category.Internet,
                    color : tmp.color.Internet
                }]
                commit('ADD_CHARTS',{
                    title : tmp.title,
                    categories : tmp.milestone,
                    yAxis_text : unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines : null,
                    showTable : false,
                    series : provider_data
                })
                if(formdata.avgTable){
                    commit('ADD_TABLE', {
                        milestone : tmp.milestone,
                        data : provider_data
                    })
                }
            }else{ // === SPECIFY SERVICE ===
                if(formdata.graphLine){
                     tmp.category[formdata.typeService].unshift(null)
                     tmp.category[formdata.typeService].push(null)
                }
                tmp.series = [{
                    name : service_th[formdata.typeService],
                    data : tmp.category[formdata.typeService],
                    color : tmp.color[formdata.typeService]
                }]
                if (formdata.graphLine) {  // === REGULATE LINE ===
                    let maxval = 0, maxline = [], reguline = []
                    for(let val of tmp.category[formdata.typeService]){
                        maxval = maxval < val ? val : maxval
                    }
                    let regulate_val = regulator[formdata.typeService.toLowerCase() + '_service_rate']
                        regulate_val = parseFloat(regulate_val)
                        tmp.max = tmp.milestone.length
                        tmp.min = 1
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                        tmp.graphLine = []
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                    if(formdata.type_report == 'between_month'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +'ระหว่างเดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงเดือน'+month_th[moment(daterange[1]).month()]+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +'เดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }
                }else{ // === NO REGULATE LINE ===
                    if(formdata.type_report == 'between_month'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +'ระหว่างเดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงเดือน'+month_th[moment(daterange[1]).month()]+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +'เดือน'+month_th[moment(daterange[0]).month()]+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                    }
                }
                commit('ADD_CHARTS', {
                    title: tmp.title,
                    categories: tmp.milestone,
                    yAxis_text: unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines: null,
                    max: tmp.max,
                    min: tmp.min,
                    showTable: false,
                    series: tmp.series
                })
                let milestone = tmp.milestone
                let series = tmp.series
                if(formdata.graphLine){
                    milestone = JSON.parse(JSON.stringify(milestone))
                    milestone.pop()
                    milestone.shift()
                    series = JSON.parse(JSON.stringify(series))
                    for(let item of series){
                        item.data.pop()
                        item.data.shift()
                    }
                }
                commit('ADD_TABLE',{
                    milestone : milestone,
                    data : series
                })
            }
        }
        commit('SHOW_DATA_TABLE', !!formdata.avgTable)
        commit('SET_REGULATE_STATUS', !!formdata.graphLine)
        setTimeout(function() { loadingInstance.close() }, 250)
    },
    async reportQuarter({commit},formdata){ // === REPORT QUARTER ===
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await reportG2.getAllReportData(formdata)
        if(!result.data)  {
            setTimeout(function() { loadingInstance.close() }, 250)
            return commit('DATA_NOT_FOUND',true)
        }
        let proportion = await reportG2.getProportionMobileRate()
            proportion = proportion.data[0] || null
            proportion['main'] = proportion.proportion_main_promotion*0.01 || 1
            proportion['on-top'] = proportion.proportion_ontop_promotion*0.01 || 1
        let regulator = state.regulator
            regulator = formdata.graphLine ? regulator.filter(item => item.id == formdata.graphLine)[0] : null
        let daterange = result.data.pop()
            formdata.daterange = daterange
        let tmp = {
            milestone: [],
            data: [],
            pointer: {},
            providers: {},
            category: {
                Voice: {},
                SMS: {},
                MMS: {},
                Internet: {}
            },
            bucket: {},
            count: {},
            group: {},
            average: [],
            color: {
                Voice: '#ffbb33',
                SMS: '#66b3ff',
                MMS: '#66ffb3',
                Internet: '#ff3838'
            },
            proportion : {}
        }
        let qrydata = Object.values(result.data[0])[0]
        let services = formdata.typeService ? [formdata.typeService] : Object.keys(tmp.category)

        let fq_text = '',fq_pool = [].concat(formdata.frequency)
        if(fq_pool.length == 1){
            fq_text  = 'บนคลื่นความถี่'+fq_th[fq_pool[0]]
        }else if((fq_pool.length == 2) || (fq_pool.length == 3)){
            let last_item = fq_pool.pop()
            fq_text = 'บนคลื่นความถี่'
            for(let item of fq_pool){
                fq_text += fq_th[item]+' '
            }
            fq_text += 'และ '+fq_th[last_item]
        }

        for (let date = daterange[0], end = daterange[1]; date <= end; date = moment(date).add(1, 'Q').format('YYYY-MM-DD')) {
            let quarter_key = moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY')
                tmp.milestone.push(quarter_key)
                tmp.bucket[quarter_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                tmp.count[quarter_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                tmp.group[quarter_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                tmp.proportion[quarter_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            if (formdata.compare_type == 'group') {
                for (let pv of formdata.list) {
                    for (let id of JSON.parse(pv.group_company_list)) {
                        tmp.pointer[id] = pv.group_name_th
                        for(let sv of services){
                            tmp.proportion[quarter_key][sv][id] = { 'main' : 0 , 'on-top' : 0}
                        }
                    }
                    tmp.providers[pv.group_name_th] = { color: pv.group_color_code }
                    for (let category in tmp.category) {
                        tmp.bucket[quarter_key][category][pv.group_name_th] = []
                        tmp.count[quarter_key][category][pv.group_name_th] = []
                        tmp.group[quarter_key][category][pv.group_name_th] = 0
                    }
                }
            } else {
                for (let pv of formdata.list) {
                    tmp.pointer[pv.id] = pv.brand_name
                    tmp.providers[pv.brand_name] = { color: pv.provider_color }
                    for (let category in tmp.category) {
                        tmp.bucket[quarter_key][category][pv.brand_name] = []
                        tmp.count[quarter_key][category][pv.brand_name] = []
                        tmp.group[quarter_key][category][pv.brand_name] = 0
                        tmp.proportion[quarter_key][category][pv.id] = { 'main' : 0 , "on-top" : 0}
                    }
                }
            }
        }
        if(formdata.distinguish){ // ===  CLASSIFY BY PROVIDER ===

            // SUM OF MONTH
            for(let item of qrydata){
                let quarter_key = moment(item.monthly_regulate).quarter()+'Q'+moment(item.monthly_regulate).add(543,'Y').format('YYYY')
                let month_key = moment(item.monthly_regulate).format('YYYY-MM-DD')
                if(item.price_avg){
                    tmp.bucket[quarter_key][item.service_type][tmp.pointer[item.provider_id]] = (parseFloat(tmp.bucket[quarter_key][item.service_type][tmp.pointer[item.provider_id]]) || 0) + item.price_avg
                    tmp.group[quarter_key][item.service_type][tmp.pointer[item.provider_id]] = (parseInt(tmp.group[quarter_key][item.service_type][tmp.pointer[item.provider_id]]) || 0) + 1
                }else{
                    for(let sv of services){
                        // tmp.group[quarter_key][sv][tmp.pointer[item.provider_id]] += (item[sv] > 0 && item.promotion_type == 'main') ? 1 : 0
                        tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key]
                            = tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key] 
                            ? tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv] > 0
                                ? item[sv] > 0
                                    ? tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv] * proportion[tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key][0]['promotion_type']] + item[sv] * proportion[item['promotion_type']]
                                    : tmp.bucket[quarter_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv]
                                : item[sv]
                            : [item]     
                        tmp.count[quarter_key][sv][tmp.pointer[item.provider_id]] = (parseInt(tmp.count[quarter_key][sv][tmp.pointer[item.provider_id]]) || 0) + item[sv+'_total']
                    }
                }
            }

            // SUM OF QUARTER
            for(let quarter in tmp.bucket){
                for(let sv of services){
                    for(let pv in tmp.bucket[quarter][sv]){
                        var bucket = []
                        for(let month in tmp.bucket[quarter][sv][pv]){
                            if(tmp.bucket[quarter][sv][pv][month] > 0) bucket.push(tmp.bucket[quarter][sv][pv][month])
                        }
                        tmp.bucket[quarter][sv][pv] = eval(bucket.join('+'))/bucket.length
                    }
                }
            }
            // for(let date in tmp.group){
            //     for(let service in tmp.group[date]){
            //         for(let provider in tmp.group[date][service]){
            //             if(tmp.group[date][service][provider]>1){
            //                 tmp.bucket[date][service][provider] /= (tmp.group[date][service][provider] || 1)
            //             } 
            //         }
            //     }
            // }
            if(formdata.barAvg){ // === AVERAGE COLUMN ===
                if(formdata.weighting){
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let key of tmp.milestone){
                            let pre_weight = 0
                            let total_weight = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[key][sv][provider] > 0){
                                    tmp.category[sv][provider] 
                                    ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[key][sv][provider])] 
                                pre_weight += tmp.bucket[key][sv][provider] * tmp.count[key][sv][provider]
                                total_weight += tmp.count[key][sv][provider]
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((pre_weight/total_weight)) || null)
                        }
                    }
                }else{ // === NOT WEIGHTING ===
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let date_key of tmp.milestone){
                            let sum = 0
                            let devide = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[date_key][sv][provider] > 0){
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[date_key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[date_key][sv][provider])] 
                                    sum += tmp.bucket[date_key][sv][provider]
                                    devide += 1
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((sum/devide)) || null)
                        }
                    }
                }
            }else{ // === NONE AVERAGE COLUMN ===
                for(let date_key of tmp.milestone){
                    for(let provider in tmp.providers){
                        tmp.category.Voice[provider]    ? tmp.category.Voice[provider].push(tmp.bucket[date_key].Voice[provider] > 0 ? parseFloat(tmp.bucket[date_key].Voice[provider]) : null) 
                                                        : tmp.category.Voice[provider] = [tmp.bucket[date_key].Voice[provider] > 0 ? parseFloat(tmp.bucket[date_key].Voice[provider]) : null] 
                        tmp.category.SMS[provider]      ? tmp.category.SMS[provider].push(tmp.bucket[date_key].SMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].SMS[provider]) : null)     
                                                        : tmp.category.SMS[provider] = [tmp.bucket[date_key].SMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].SMS[provider]) : null] 
                        tmp.category.MMS[provider]      ? tmp.category.MMS[provider].push(tmp.bucket[date_key].MMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].MMS[provider]) : null)     
                                                        : tmp.category.MMS[provider] = [tmp.bucket[date_key].MMS[provider] > 0 ? parseFloat(tmp.bucket[date_key].MMS[provider]) : null] 
                        tmp.category.Internet[provider] ? tmp.category.Internet[provider].push(tmp.bucket[date_key].Internet[provider] > 0 ? parseFloat(tmp.bucket[date_key].Internet[provider]) : null) 
                                                        : tmp.category.Internet[provider] = [tmp.bucket[date_key].Internet[provider] > 0 ? parseFloat(tmp.bucket[date_key].Internet[provider]) : null]
                    }
                }
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast = await reportG2.getForcastAvg(formdata)
                let devider = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast_count = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                tmp.forcast = {}
                for(let service of services){
                    tmp.forcast[service] = {}
                    for(let provider in tmp.providers){
                        tmp.forcast[service][provider] = []
                    }
                }
                for(let item of forcast.data){
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][provider_name].push(item.price_avg) 
                        devider[item.service_type][provider_name] = parseInt(devider[item.service_type][provider_name] || 0) + 1
                    }else{
                        for(let sv of services){
                            tmp.forcast[sv][provider_name].push(item[sv]*proportion[item.promotion_type])
                            tmp.forcast_count[sv][provider_name] = (tmp.forcast_count[sv][provider_name] || 0) + (item[sv] ? item.total : 0)
                        }
                        if(item.promotion_type == 'main'){
                            item.Voice > 0 ? devider.Voice[provider_name] = (devider.Voice[provider_name] ? devider.Voice[provider_name]+1 : 1) : 0
                            item.SMS > 0 ? devider.SMS[provider_name] = (devider.SMS[provider_name] ? devider.SMS[provider_name]+1 : 1) : 0
                            item.MMS > 0 ? devider.MMS[provider_name] = (devider.MMS[provider_name] ? devider.MMS[provider_name]+1 : 1) : 0
                            item.Internet > 0 ? devider.Internet[provider_name] = (devider.Internet[provider_name] ? devider.Internet[provider_name]+1 : 1) : 0
                        }
                    }
                }

                let avg = [],fc = 0 ,sv_count = 0
                if(formdata.barAvg){ 
                    if(formdata.weighting){ // === WEIGHTING AVERAGE FORCAST ===
                        for(let sv of services){
                            sv_count = eval(Object.values(tmp.forcast_count[sv]).join('+'))
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc*tmp.forcast_count[sv][provider]/sv_count)
                            }
                            tmp.average[sv].push(eval(avg.join('+')))
                        }
                    }else{ // === NORMAL AVERAGE FORCAST ===
                        for(let sv of services){
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc)
                            }
                            tmp.average[sv].push(eval(avg.join('+'))/avg.length)
                        }
                    }
                }else{ // === JUST FORCAST ===
                    for(let sv of services){
                        for(let provider in tmp.providers){
                            fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                            tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                        }
                    }
                }
            }
            for(let service_name of services){
                let maxval = 0, maxline = [], reguline = []
                if(formdata.type_report == 'quarter'){// === QUARTER ===
                    if(formdata.graphLine){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +" ในไตรมาสที่ "+formdata.type_data.quarter+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }else{// === NO GRAPH LINE ===
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +' ในไตรมาสที่ '+formdata.type_data.quarter+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }
                }else{ // === BETWEEN QUARTER ===
                    if(formdata.graphLine){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของบริการโทรศัพท์เคลื่อนที่"+fq_text
                        +" ในไตรมาสที่ "+formdata.type_data.quarterfrom+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงไตรมาสที่ '+formdata.type_data.quarterto+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผุ้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }else{// === NO GRAPH LINE ===
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[service_name]+" ของบริการโทรศัพท์เคลื่อนที่"+fq_text
                        +' ในไตรมาสที่ '+formdata.type_data.quarterfrom+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงไตรมาสที่ '+formdata.type_data.quarterto+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }
                }
                tmp.series = []
                for(let provider in tmp.category[service_name]){
                    maxval = maxval > Math.max(...tmp.category[service_name][provider]) ? maxval : Math.max(...tmp.category[service_name][provider])
                    if(formdata.graphLine){
                        tmp.category[service_name][provider].unshift(null)
                        tmp.category[service_name][provider].push(null)
                    } 
                    tmp.series.push({
                        name : provider,
                        data : tmp.category[service_name][provider],
                        color : tmp.providers[provider].color
                    })
                }
                if (formdata.graphLine) { // === REGULATE LINE ===
                    let regulate_val = regulator[service_name.toLowerCase() + '_service_rate']
                        regulate_val = parseFloat(regulate_val)
                        tmp.min = 1
                        tmp.max = tmp.milestone.length
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                }
                if (formdata.barAvg) {
                    if(formdata.graphLine){
                        tmp.average[service_name].push(null)
                        tmp.average[service_name].unshift(null)
                    }
                    tmp.series.push({
                        name: 'ค่าเฉลี่ย',
                        data: tmp.average[service_name],
                        color: '#ffcc00'
                    })
                }
                commit('ADD_CHARTS', {
                    title: tmp.title,
                    categories: tmp.milestone,
                    yAxis_text: unit_service[service_name] || 'บาท',
                    yAxis_lines: null,
                    max : tmp.max,
                    min : tmp.min,
                    series: tmp.series,
                    showTable: false,
                })
                if(formdata.avgTable){
                    let milestone = JSON.parse(JSON.stringify(tmp.milestone))
                    let provider_data = JSON.parse(JSON.stringify(tmp.series))
                    if(formdata.graphLine){
                        milestone.pop()
                        milestone.shift()
                        for(let item of provider_data){
                            item.data.pop()
                            item.data.shift()
                        }
                    }
                    commit('ADD_TABLE',{
                        milestone : milestone,
                        data : provider_data
                    })
                }
            }
        }else{ // === NO CLASSIFY ===
            for(let item of qrydata){
                let date_key = moment(item.monthly_regulate).quarter() + 'Q' + moment(item.monthly_regulate).add(543, 'Y').format('YYYY')
                if(item.price_avg){
                    tmp.proportion[date_key][item.service_type][item.provider_id]['main'] = [item.price_avg].concat(tmp.proportion[date_key][item.service_type][item.provider_id]['main'] || [])
                    tmp.proportion[date_key][item.service_type][item.provider_id]['on-top'] = []
                }else{
                    for(let sv of services){
                        tmp.proportion[date_key][sv][item.provider_id][item.promotion_type] = [item[sv]].concat(tmp.proportion[date_key][sv][item.provider_id][item.promotion_type] || [])  
                    }
                }
            }
            for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'Q').format('YYYY-MM-DD')){
               let date_key = moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY')
               for(let sv of services){
                    tmp.bucket[date_key][sv] = []
                    tmp.category[sv] = tmp.category[sv].length ? tmp.category[sv] : []
                    for(let pv in tmp.proportion[date_key][sv]){
                        var main = tmp.proportion[date_key][sv][pv]['main'] == 0 ? 0 : eval(tmp.proportion[date_key][sv][pv]['main'].filter(item => item > 0).join('+'))/tmp.proportion[date_key][sv][pv]['main'].length
                        var ontop = tmp.proportion[date_key][sv][pv]['on-top'] == 0 ? 0 : eval(tmp.proportion[date_key][sv][pv]['on-top'].filter(item => item > 0).join('+'))/tmp.proportion[date_key][sv][pv]['on-top'].length
                        var sum = ontop ? main ? (main*proportion['main'])+(ontop*proportion['on-top']) : ontop : main
                        if(sum) tmp.bucket[date_key][sv].push(sum)
                    }
                    tmp.bucket[date_key][sv] = eval(tmp.bucket[date_key][sv].join('+')) / tmp.bucket[date_key][sv].length
                }
                for(let service of services){
                    tmp.category[service].push(parseFloat(tmp.bucket[date_key][service]))
                }
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast =  await reportG2.getForcastAvg(formdata)
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                for(let provider in tmp.providers){
                    tmp.forcast.Voice[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.SMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.MMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.Internet[provider] = {'main' : null , 'on-top' : null}
                }
                for(let item of forcast.data){ // === QUERY DATA FORCAST ===
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][tmp.pointer[item.provider_id]]['main'] = item.price_avg
                    }else{
                        for(let service of services){
                            tmp.forcast[service][tmp.pointer[item.provider_id]][item.promotion_type] = item[service]
                        }
                    }
                }
                for(let service of services){ // === PROPORTION OF FORCAST DATA ===
                    for(let provider in tmp.forcast[service]){
                        var item = tmp.forcast[service][provider]
                        tmp.forcast[service][provider] = item['on-top'] > 0 ? item['main'] > 0 ? (item['main']*proportion['main'])+(item['on-top']*proportion['on-top']) : item['on-top'] : item['main']
                    }
                    var dataset = Object.values(tmp.forcast[service]).filter(item => item > 0)
                    var avg = eval(dataset.join('+')) / Object.values(tmp.forcast[service]).length
                    tmp.category[service].push(avg)
                }
            }
            if(!formdata.typeService){ // === ALL SERVICE TYPE ===
                if(formdata.type_report == 'between_quarter'){
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +" ในไตรมาสที่ "+formdata.type_data.quarterfrom+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                    +' ถึงไตรมาสที่ '+formdata.type_data.quarterto+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                }else{
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +" ในไตรมาสที่ "+formdata.type_data.quarter+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                }
                let provider_data = [{
                    name : 'บริการประเภทเสียง',
                    data : tmp.category.Voice,
                    color : tmp.color.Voice
                },{
                    name : 'SMS',
                    data : tmp.category.SMS,
                    color : tmp.color.SMS
                },{
                    name : 'MMS',
                    data : tmp.category.MMS,
                    color : tmp.color.MMS
                },{
                    name : 'Internet',
                    data : tmp.category.Internet,
                    color : tmp.color.Internet
                }]
                commit('ADD_CHARTS',{
                    title : tmp.title,
                    categories : tmp.milestone,
                    yAxis_text : unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines : null,
                    showTable : false,
                    series : provider_data
                })
                if(formdata.avgTable){
                    commit('ADD_TABLE',{
                        milestone : tmp.milestone,
                        data : provider_data
                    })
                }
            }else{ // === SPECIFY SERVICE ===
                if(formdata.graphLine){
                    tmp.category[formdata.typeService].unshift(null)
                    tmp.category[formdata.typeService].push(null)
                } 
                tmp.series = [{
                    name : formdata.typeService,
                    data : tmp.category[formdata.typeService],
                    color : tmp.color[formdata.typeService]
                }]
                if (formdata.graphLine) { // === REGULATE LINE ===
                    let maxval = 0, maxline = [], reguline = []
                    for(let val of tmp.category[formdata.typeService]){
                        maxval = maxval < val ? val : maxval
                    }
                    let regulate_val = regulator[formdata.typeService.toLowerCase() + '_service_rate']
                        regulate_val = parseFloat(regulate_val)
                        tmp.max = tmp.milestone.length
                        tmp.min = 1
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                        tmp.graphLine = []
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                    if(formdata.type_report == 'between_quarter'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +" ในไตรมาสที่ "+formdata.type_data.quarterfrom+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงไตรมาสที่ '+formdata.type_data.quarterto+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +" ในไตรมาสที่ "+formdata.type_data.quarter+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }
                }else{ // === NO REGULATE LINE ===
                    if(formdata.type_report == 'between_quarter'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ในไตรมาสที่ "+formdata.type_data.quarterfrom+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงไตรมาสที่ '+formdata.type_data.quarterto+' ปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ในไตรมาสที่ "+formdata.type_data.quarter+' ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                    }
                }
                commit('ADD_CHARTS',{
                    title : tmp.title,
                    categories : tmp.milestone,
                    yAxis_text : unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines : null,
                    max : tmp.max,
                    min : tmp.min,
                    showTable : false,
                    series : tmp.series
                })
                if(formdata.avgTable){
                    let milestone = JSON.parse(JSON.stringify(tmp.milestone))
                    let series = JSON.parse(JSON.stringify(tmp.series))
                    if(formdata.graphLine){
                        milestone.pop()
                        milestone.shift()    
                        for(let item of series){
                            item.data.pop()
                            item.data.shift()
                        }                
                    }
                    commit('ADD_TABLE', {
                        milestone : milestone,
                        data : series
                    })
                }
            }
        }
        commit('SHOW_DATA_TABLE', formdata.avgTable ? true : false)
        commit('SET_REGULATE_STATUS', !!formdata.graphLine)
        setTimeout(function() { loadingInstance.close() }, 250)
    },
    async reportYear({state,commit},formdata){ // === REPORT YEAR ===
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await reportG2.getAllReportData(formdata)
        if(!result.data) {
            setTimeout(function() { loadingInstance.close() }, 250)
            return commit('DATA_NOT_FOUND',true)
        }
        let proportion = await reportG2.getProportionMobileRate()
            proportion = proportion.data[0] || null
            proportion['main'] = proportion.proportion_main_promotion*0.01 || 1
            proportion['on-top'] = proportion.proportion_ontop_promotion*0.01 || 1
        let regulator = state.regulator
            regulator = formdata.graphLine ? regulator.filter(item => item.id == formdata.graphLine)[0] : null
        let daterange = result.data.pop()
            formdata.daterange = daterange
        let tmp = {
            milestone: [],
            data: [],
            pointer: {},
            providers: {},
            category: {
                Voice: {},
                SMS: {},
                MMS: {},
                Internet: {}
            },
            bucket: {},
            count: {},
            group: {},
            average: [],
            color: {
                Voice: '#ffbb33',
                SMS: '#66b3ff',
                MMS: '#66ffb3',
                Internet: '#ff3838'
            },
            proportion : {}
        }
        let qrydata = Object.values(result.data[0])[0]
        let services = formdata.typeService ? [formdata.typeService] : Object.keys(tmp.category)
        let fq_text = '',fq_pool = [].concat(formdata.frequency)
        if(fq_pool.length == 1){
            fq_text  = 'บนคลื่นความถี่'+fq_th[fq_pool[0]]
        }else if((fq_pool.length == 2) || (fq_pool.length == 3)){
            let last_item = fq_pool.pop()
            fq_text = 'บนคลื่นความถี่'
            for(let item of fq_pool){
                fq_text += fq_th[item]+' '
            }
            fq_text += 'และ '+fq_th[last_item]
        }
        for (let date = daterange[0], end = daterange[1]; date <= end; date = moment(date).add(1, 'Y').format('YYYY-MM-DD')) {
            let date_key = moment(date).add(543, 'Y').format('YYYY')
            tmp.milestone.push(date_key)
            tmp.bucket[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            tmp.count[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            tmp.group[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            tmp.proportion[date_key] = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
            if (formdata.compare_type == 'group') {
                for (let item of formdata.list) {
                    for (let id of JSON.parse(item.group_company_list)) {
                        tmp.pointer[id] = item.group_name_th
                        for(let sv of services){
                            tmp.proportion[date_key][sv][id] = { 'main' : 0 , 'on-top' : 0}
                        }
                    }
                    tmp.providers[item.group_name_th] = { color: item.group_color_code }
                    for (let category in tmp.category) {
                        tmp.bucket[date_key][category][item.group_name_th] = []
                        tmp.count[date_key][category][item.group_name_th] = []
                        tmp.group[date_key][category][item.group_name_th] = 0
                    }
                }
            } else {
                for (let pv of formdata.list) {
                    tmp.pointer[pv.id] = pv.brand_name
                    tmp.providers[pv.brand_name] = { color: pv.provider_color }
                    for (let category in tmp.category) {
                        tmp.bucket[date_key][category][pv.brand_name] = []
                        tmp.count[date_key][category][pv.brand_name] = []
                        tmp.group[date_key][category][pv.brand_name] = 0
                        tmp.proportion[date_key][category][pv.id] = { 'main' : 0 , 'on-top' : 0}
                    }
                }
            }
        }
        if(formdata.distinguish){ // ===  CLASSIFY BY PROVIDER ===
            // SUM OF MONTH
            for(let item of qrydata){
                let year_key = moment(item.monthly_regulate).add(543,'Y').format('YYYY')
                let month_key = moment(item.monthly_regulate).format('YYYY-MM-DD')
                if(item.price_avg){
                    tmp.bucket[year_key][item.service_type][tmp.pointer[item.provider_id]]
                        = (parseFloat(tmp.bucket[year_key][item.service_type][tmp.pointer[item.provider_id]]) || 0) + item.price_avg
                    tmp.group[year_key][item.service_type][tmp.pointer[item.provider_id]]
                        = (parseInt(tmp.group[year_key][item.service_type][tmp.pointer[item.provider_id]]) || 0) + 1
                }else{
                    for(let sv of services){
                        tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key]
                            = tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key] 
                            ? tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv] > 0
                                ? item[sv] > 0
                                    ? tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv] * proportion[tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key][0]['promotion_type']] + item[sv] * proportion[item['promotion_type']]
                                    : tmp.bucket[year_key][sv][tmp.pointer[item.provider_id]][month_key][0][sv]
                                : item[sv]
                            : [item]
                        tmp.group[year_key][sv][tmp.pointer[item.provider_id]] += (item[sv] > 0 && item.promotion_type == 'main') ? 1 : 0
                        tmp.count[year_key][sv][tmp.pointer[item.provider_id]] = (parseInt(tmp.count[year_key][sv][tmp.pointer[item.provider_id]]) || 0) + item[sv+'_total']
                    }
                }
            }
            // SUM OF YEAR
            for(let year in tmp.bucket){
                for(let sv of services){
                    for(let pv in tmp.bucket[year][sv]){
                        var bucket = []
                        for(let month in tmp.bucket[year][sv][pv]){
                            if(tmp.bucket[year][sv][pv][month] > 0) bucket.push(tmp.bucket[year][sv][pv][month])
                        }
                        tmp.bucket[year][sv][pv] = eval(bucket.join('+'))/bucket.length
                    }
                }
            }
            
            // for(let date in tmp.group){
            //     for(let service in tmp.group[date]){
            //         for(let provider in tmp.group[date][service]){
            //             if(tmp.group[date][service][provider]>1){
            //                 tmp.bucket[date][service][provider] /= (tmp.group[date][service][provider] || 1)
            //             } 
            //         }
            //     }
            // }
            if(formdata.barAvg){ 
                if(formdata.weighting){ // === WEIGHTING ===
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let key of tmp.milestone){
                            let pre_weight = 0
                            let total_weight = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[key][sv][provider] > 0){
                                    tmp.category[sv][provider] 
                                    ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[key][sv][provider])] 
                                pre_weight += tmp.bucket[key][sv][provider] * tmp.count[key][sv][provider]
                                total_weight += tmp.count[key][sv][provider]
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((pre_weight/total_weight)) || null)
                        }
                    }
                }else{ // === NO WEIGHT ===
                    for(let sv of services){
                        tmp.average[sv] = []
                        for(let key of tmp.milestone){
                            let sum = 0
                            let devide = 0
                            for(let provider in tmp.providers){
                                if(tmp.bucket[key][sv][provider] > 0){
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(parseFloat(tmp.bucket[key][sv][provider])) 
                                    : tmp.category[sv][provider] = [parseFloat(tmp.bucket[key][sv][provider])] 
                                    sum += tmp.bucket[key][sv][provider]
                                    devide += 1
                                }else{
                                    tmp.category[sv][provider] ? tmp.category[sv][provider].push(null) : tmp.category[sv][provider] = [null]
                                }
                            }
                            tmp.average[sv].push(parseFloat((sum/devide)) || null)
                        }
                    }
                }
            }else{  // === NO AVERAGE ===
                for(let key of tmp.milestone){
                    for(let provider in tmp.providers){
                        tmp.category.Voice[provider]    ? tmp.category.Voice[provider].push(tmp.bucket[key].Voice[provider] > 0 ? parseFloat(tmp.bucket[key].Voice[provider]) : null) 
                                                        : tmp.category.Voice[provider] = [tmp.bucket[key].Voice[provider] > 0 ? parseFloat(tmp.bucket[key].Voice[provider]) : null] 
                        tmp.category.SMS[provider]      ? tmp.category.SMS[provider].push(tmp.bucket[key].SMS[provider] > 0 ? parseFloat(tmp.bucket[key].SMS[provider]) : null)     
                                                        : tmp.category.SMS[provider] = [tmp.bucket[key].SMS[provider] > 0 ? parseFloat(tmp.bucket[key].SMS[provider]) : null] 
                        tmp.category.MMS[provider]      ? tmp.category.MMS[provider].push(tmp.bucket[key].MMS[provider] > 0 ? parseFloat(tmp.bucket[key].MMS[provider]) : null)     
                                                        : tmp.category.MMS[provider] = [tmp.bucket[key].MMS[provider] > 0 ? parseFloat(tmp.bucket[key].MMS[provider]) : null] 
                        tmp.category.Internet[provider] ? tmp.category.Internet[provider].push(tmp.bucket[key].Internet[provider] > 0 ? parseFloat(tmp.bucket[key].Internet[provider]) : null) 
                                                        : tmp.category.Internet[provider] = [tmp.bucket[key].Internet[provider] > 0 ? parseFloat(tmp.bucket[key].Internet[provider]) : null]
                    }
                }
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast = await reportG2.getForcastAvg(formdata)
                let devider = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast_count = {Voice : {}, SMS : {}, MMS : {}, Internet : {}}
                tmp.forcast = {}
                for(let service of services){
                    tmp.forcast[service] = {}
                    for(let provider in tmp.providers){
                        tmp.forcast[service][provider] = []
                    }
                }
                for(let item of forcast.data){
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][provider_name].push(item.price_avg) 
                        devider[item.service_type][provider_name] = parseInt(devider[item.service_type][provider_name] || 0) + 1
                    }else{
                        for(let service of services){
                            tmp.forcast[service][provider_name].push(item[service]*proportion[item.promotion_type])
                            tmp.forcast_count[service][provider_name] = (tmp.forcast_count[service][provider_name] || 0) + (item[service] ? item.total : 0)
                        }
                        if(item.promotion_type == 'main'){
                            item.Voice > 0 ? devider.Voice[provider_name] = (devider.Voice[provider_name] ? devider.Voice[provider_name]+1 : 1) : 0
                            item.SMS > 0 ? devider.SMS[provider_name] = (devider.SMS[provider_name] ? devider.SMS[provider_name]+1 : 1) : 0
                            item.MMS > 0 ? devider.MMS[provider_name] = (devider.MMS[provider_name] ? devider.MMS[provider_name]+1 : 1) : 0
                            item.Internet > 0 ? devider.Internet[provider_name] = (devider.Internet[provider_name] ? devider.Internet[provider_name]+1 : 1) : 0
                        }
                    }
                }

                let avg = [],fc = 0 ,sv_count = 0
                if(formdata.barAvg){ 
                    if(formdata.weighting){ // === WEIGHTING AVERAGE FORCAST ===
                        for(let sv of services){
                            sv_count = eval(Object.values(tmp.forcast_count[sv]).join('+'))
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc*tmp.forcast_count[sv][provider]/sv_count)
                            }
                            tmp.average[sv].push(eval(avg.join('+')))
                        }
                    }else{ // === NORMAL AVERAGE FORCAST ===
                        for(let sv of services){
                            avg = []
                            for(let provider in tmp.providers){
                                fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                                tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                                avg.push(fc)
                            }
                            tmp.average[sv].push(eval(avg.join('+'))/avg.length)
                        }
                    }
                }else{ // === JUST FORCAST ===
                    for(let sv of services){
                        for(let provider in tmp.providers){
                            fc = tmp.forcast[sv][provider] ? eval(tmp.forcast[sv][provider].join('+'))/devider[sv][provider] : null
                            tmp.category[sv][provider].push((fc > 0 ? parseFloat(fc) : null))
                        }
                    }
                }
            }
            for(let service_name of services){
                let maxval = 0, maxline = [], reguline = []
                tmp.series = []
                for(let provider in tmp.category[service_name]){
                    maxval = maxval > Math.max(...tmp.category[service_name][provider]) ? maxval : Math.max(...tmp.category[service_name][provider])
                    if(formdata.graphLine){ 
                        tmp.category[service_name][provider].unshift(null)
                        tmp.category[service_name][provider].push(null)
                    }
                    tmp.series.push({
                        name : provider,
                        data : tmp.category[service_name][provider],
                        color : tmp.providers[provider].color
                    })
                }
                if (formdata.graphLine) { // === REGULATE LINE ===
                    let regulate_val = parseFloat((regulator[service_name.toLowerCase() + '_service_rate']))
                        tmp.min = 1
                        tmp.max = tmp.milestone.length
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                    if(formdata.type_report == 'year'){
                        tmp.title = 'อัตราค่าบริการเฉลี่ยของ'+service_th[service_name]+' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'+fq_text
                        +'ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }else{
                        tmp.title = 'อัตราค่าบริการเฉลี่ยของ'+service_th[service_name]+' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'+fq_text
                        +'ระหว่างปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่และเปรียบเทียบกับ'+regulator.service_name
                    }
                }else{ // === NO REGULATE LINE ===
                    if(formdata.type_report == 'year'){
                        tmp.title = 'อัตราค่าบริการเฉลี่ยของ'+service_th[service_name]+' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'+fq_text
                        +'ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }else{
                        tmp.title = 'อัตราค่าบริการเฉลี่ยของ'+service_th[service_name]+' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'+fq_text
                        +'ระหว่างปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')+' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' โดยจำแนกตามผู้ให้บริการโทรศัพท์เคลื่อนที่'
                    }
                }
                if (formdata.barAvg) { // === AVERAGE COLUMN ===
                    if(formdata.graphLine){
                        tmp.average[service_name].push(null)
                        tmp.average[service_name].unshift(null)
                    }
                    tmp.series.push({
                        name: 'ค่าเฉลี่ย',
                        data: tmp.average[service_name],
                        color: '#ffcc00'
                    })
                }
                commit('ADD_CHARTS', {
                    title: tmp.title,
                    categories: tmp.milestone,
                    yAxis_text: unit_service[service_name] || 'บาท',
                    yAxis_lines: null,
                    max : tmp.max,
                    min : tmp.min,
                    series: tmp.series,
                    showTable: false,
                })
                if(formdata.avgTable){ // === DATA TABLE ===
                    let milestone = JSON.parse(JSON.stringify(tmp.milestone))
                    let provider_data = JSON.parse(JSON.stringify(tmp.series))
                    if(formdata.graphLine){
                        milestone.shift()
                        milestone.pop()
                        for(let item of provider_data){
                            item.data.pop()
                            item.data.shift()
                        }
                    }
                    commit('ADD_TABLE',{
                        milestone : milestone,
                        data : provider_data
                    })
                }
            }
        }else{ // === NO CLASSIFY ===
            for(let item of qrydata){
                let date_key = moment(item.monthly_regulate).add(543, 'Y').format('YYYY')
                if(item.price_avg){
                    tmp.proportion[date_key][item.service_type][item.provider_id]['main'] = [item.price_avg].concat(tmp.proportion[date_key][item.service_type][item.provider_id]['main'] || [])
                    tmp.proportion[date_key][item.service_type][item.provider_id]['on-top'] = []
                }else{
                    tmp.proportion[date_key]['Voice'][item.provider_id][item.promotion_type] = [item.Voice].concat(tmp.proportion[date_key]['Voice'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['SMS'][item.provider_id][item.promotion_type] = [item.SMS].concat(tmp.proportion[date_key]['SMS'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['MMS'][item.provider_id][item.promotion_type] = [item.MMS].concat(tmp.proportion[date_key]['MMS'][item.provider_id][item.promotion_type] || [])
                    tmp.proportion[date_key]['Internet'][item.provider_id][item.promotion_type] = [item.Internet].concat(tmp.proportion[date_key]['Internet'][item.provider_id][item.promotion_type] || [])
                }
            }
            for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'Y').format('YYYY-MM-DD')){
               let date_key = moment(date).add(543, 'Y').format('YYYY')
               for(let sv of services){
                    tmp.bucket[date_key][sv] = []
                    tmp.category[sv] = tmp.category[sv].length ? tmp.category[sv] : []
                    for(let pv in tmp.proportion[date_key][sv]){
                        var main = tmp.proportion[date_key][sv][pv]['main'] == 0 ? 0 : eval(tmp.proportion[date_key][sv][pv]['main'].filter(item => item > 0).join('+'))/tmp.proportion[date_key][sv][pv]['main'].length
                        var ontop = tmp.proportion[date_key][sv][pv]['on-top'] == 0 ? 0 : eval(tmp.proportion[date_key][sv][pv]['on-top'].filter(item => item > 0).join('+'))/tmp.proportion[date_key][sv][pv]['on-top'].length
                        var sum = ontop ? main ? (main*proportion['main'])+(ontop*proportion['on-top']) : ontop : main
                        if(sum) tmp.bucket[date_key][sv].push(sum)
                    }
                    tmp.bucket[date_key][sv] = eval(tmp.bucket[date_key][sv].join('+')) / tmp.bucket[date_key][sv].length
                }
                for(let sv of services){
                    tmp.category[sv].push(parseFloat(tmp.bucket[date_key][sv]))
                }       
            }
            if(formdata.forcast){ // === FORCAST DATA ===
                let forcast =  await reportG2.getForcastAvg(formdata)
                let provider_name
                tmp.milestone.push('แนวโน้ม')
                tmp.forcast = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
                for(let provider in tmp.providers){
                    tmp.forcast.Voice[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.SMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.MMS[provider] = {'main' : null , 'on-top' : null}
                    tmp.forcast.Internet[provider] = {'main' : null , 'on-top' : null}
                }
                for(let item of forcast.data){ // === QUERY DATA FORCAST ===
                    provider_name = tmp.pointer[item.provider_id]
                    if(item.price_avg){
                        tmp.forcast[item.service_type][tmp.pointer[item.provider_id]]['main'] = item.price_avg
                    }else{
                        tmp.forcast.Voice[tmp.pointer[item.provider_id]][item.promotion_type] = item.Voice
                        tmp.forcast.SMS[tmp.pointer[item.provider_id]][item.promotion_type] = item.SMS
                        tmp.forcast.MMS[tmp.pointer[item.provider_id]][item.promotion_type] = item.MMS
                        tmp.forcast.Internet[tmp.pointer[item.provider_id]][item.promotion_type] = item.Internet
                    }
                }
                for(let service of services){ // === PROPORTION OF FORCAST DATA ===
                    for(let provider in tmp.forcast[service]){
                        var item = tmp.forcast[service][provider]
                        tmp.forcast[service][provider] = item['on-top'] > 0 ? item['main'] > 0 ? (item['main']*proportion['main'])+(item['on-top']*proportion['on-top']) : item['on-top'] : item['main']
                    }
                    var dataset = Object.values(tmp.forcast[service]).filter(item => item > 0)
                    var avg = eval(dataset.join('+')) / dataset.length
                    tmp.category[service].push(avg)
                }
            }
            if(!formdata.typeService){ // === ALL SERVICE ===
                if(formdata.type_report == 'between_year'){
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +"ระหว่างปี พ.ศ. "+moment(daterange[0]).add(543,'Y').format('YYYY')
                    +' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                }else{
                    tmp.title = "ภาพรวมอัตราค่าบริการเฉลี่ยของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                    +'ปี พ.ศ. '+moment(daterange[0]).add(543,'Y').format('YYYY')
                }
                let provider_data = [{
                    name : 'บริการประเภทเสียง',
                    data : tmp.category.Voice,
                    color : tmp.color.Voice
                },{
                    name : 'SMS',
                    data : tmp.category.SMS,
                    color : tmp.color.SMS
                },{
                    name : 'MMS',
                    data : tmp.category.MMS,
                    color : tmp.color.MMS
                },{
                    name : 'Internet',
                    data : tmp.category.Internet,
                    color : tmp.color.Internet
                }]
                commit('ADD_CHARTS',{
                    title : tmp.title,
                    categories : tmp.milestone,
                    yAxis_text : unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines : null,
                    showTable : false,
                    series : provider_data
                })
                if(formdata.avgTable){
                    let milestone = Object.assign({},tmp.milestone)
                    let series = Object.assign({},provider_data)
                    if(formdata.graphLine){
                        milestone.pop()
                        milestone.shift()
                        for(let item of series){
                            item.data.pop()
                            item.data.shift()
                        }
                    }
                    commit('ADD_TABLE',{
                        milestone : milestone,
                        data : series
                    })
                }
            }else{ // === SPECIFY SERVICE ===
                if(formdata.graphLine){
                    tmp.category[formdata.typeService].unshift(null)
                    tmp.category[formdata.typeService].push(null)
                }
                tmp.series = [{
                    name : formdata.typeService,
                    data : tmp.category[formdata.typeService],
                    color : tmp.color[formdata.typeService]
                }]
                if (formdata.graphLine) { // === REGULATE LINE ===
                    let maxval = 0, maxline = [], reguline = []
                    for(let val of tmp.category[formdata.typeService]){
                        maxval = maxval < val ? val : maxval
                    }
                    let regulate_val = regulator[formdata.typeService.toLowerCase() + '_service_rate']
                        regulate_val = parseFloat(regulate_val)
                        tmp.max = tmp.milestone.length
                        tmp.min = 1
                        tmp.milestone.push('')
                        tmp.milestone.unshift('')
                        tmp.graphLine = []
                    for (let item of tmp.milestone) {
                        maxline.push(maxval)
                        reguline.push(regulate_val)
                    }
                    // === SET START POINT OF REGULATE LINE IN EXPORT ===
                    maxline[0] = null
                    reguline[0] = null
                    tmp.series.push({
                        name: 'ค่าบริการเฉลี่ยสูงสุด ของผู้ให้บริการ',
                        type: 'spline',
                        data: maxline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'shortdot',
                        pointPlacement : -0.5
                    })
                    tmp.series.push({
                        name: regulator.service_name,
                        type: 'spline',
                        data: reguline,
                        color: '#d33',
                        marker: {
                            enabled: false
                        },
                        pointPlacement : -0.5
                    })
                    if(formdata.type_report == 'between_year'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ระหว่างปี พ.ศ. "+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ปี พ.ศ. "+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' และเปรียบเทียบกับ'+regulator.service_name
                    }
                }else{ // === NO REGULATE LINE ===
                    if(formdata.type_report == 'between_year'){
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ระหว่างปี พ.ศ. "+moment(daterange[0]).add(543,'Y').format('YYYY')
                        +' ถึงปี พ.ศ. '+moment(daterange[1]).add(543,'Y').format('YYYY')
                    }else{
                        tmp.title = "อัตราค่าบริการเฉลี่ยของ"+service_th[formdata.typeService]+" ของผู้ให้บริการโทรศัพท์เคลื่อนที่"+fq_text
                        +"ปี พ.ศ. "+moment(daterange[0]).add(543,'Y').format('YYYY')
                    }
                }
                commit('ADD_CHARTS',{
                    title : tmp.title,
                    categories : tmp.milestone,
                    yAxis_text : unit_service[formdata.typeService] || 'บาท',
                    yAxis_lines : null,
                    max : tmp.max,
                    min : tmp.min,
                    showTable : false,
                    series : tmp.series
                })
                if(formdata.avgTable){
                    let milestone = JSON.parse(JSON.stringify(tmp.milestone))
                    let series = JSON.parse(JSON.stringify(tmp.series))
                    if(formdata.graphLine){
                        milestone.pop()
                        milestone.shift()
                        for(let item of series){
                            item.data.pop()
                            item.data.shift()
                        }
                    }
                    commit('ADD_TABLE',{
                        milestone : milestone,
                        data : series
                    })
                }
            }
        }
        commit('SHOW_DATA_TABLE', (formdata.avgTable ? true : false))
        commit('SET_REGULATE_STATUS', !!formdata.graphLine)
        setTimeout(function() { loadingInstance.close() }, 250)
    }

}

const mutations = {
    PROVIDER_GROUP(state, data) {
        state.provider_group = data
    },
    PROVIDER_LIST(state, data) {
        state.provider_list = data
    },
    DATA_NOT_FOUND(state, status) {
        state.showDataNotFound = status
        state.chartResult = !status
    },
    ADD_CHARTS(state, obj) {
        state.displayCharts.push({
            chart: {
                type: 'column'
            },
            title: {
                text: obj.title
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: obj.categories,
                crosshair: true,
                max: obj.max,
                min: obj.min
            },
            yAxis: {
                // min: 0,
                title: {
                    text: obj.yAxis_text
                },
                plotLines: obj.yAxis_lines,
                labels: {
                    formatter: function () {
                        var label = this.axis.defaultLabelFormatter.call(this)
                        return (label > 0 ? (+label).toFixed(2) : label)
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.2f} บาท</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    borderWidth: 0,
                    dataLabels: {
                        rotation: 0,
                        y: -10,
                        enabled: true,
                        format: '{point.y:.2f}',
                        // style : {
                        //     fontSize: '9px'
                        // },
                        overflow: "allow",
                        crop: false,
                        allowOverlap: true
                    }
                }
            },
            series: obj.series,
            credits: {
                enabled: false
            },
            exporting: {
                showTable: obj.showTable,
                csv: {
                    columnHeaderFormatter: function (item, key) {
                        if (!item || item.coll == "xAxis") {
                            return ''
                        } else {
                            return item.name;
                        }
                    }
                },
                buttons: {
                    contextButton: {
                      menuItems: [
                        'viewFullscreen',
                        'printChart',
                        'separator',
                        'downloadPNG',
                        'downloadJPEG',
                        'downloadSVG',
                        'separator',
                        'downloadCSV',
                        'downloadXLS'
                      ]
                    }
                }
            },
        })
        state.loading = false
    },
    CLEAR_CHARTS(state) {
        state.loading = true
        state.displayCharts = []
        state.dataTable = []
        state.showDataTable = false
    },
    ADD_TABLE(state, dataTable) {
        state.dataTable.push(dataTable)
    },
    SHOW_DATA_TABLE(state, status) {
        state.showDataTable = status
    },
    SET_REGULATE_LIST(state, items){
        state.regulator = items
    },
    SET_REGULATE_STATUS(state, status){
        state.showRegulate = status
    }
};

export const Report_G2 = {
    namespaced: true,
    state,
    actions,
    mutations
};